import '../../less/account-controls-popover.less';
import React, { Component } from 'react';
import { Row, Col, Card, Divider, Icon } from 'antd';
import { ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';

const { logout } = ssSessionUtils;

class Type extends Component {
    constructor(props) { super(props); }
    render() {
        const { profile } = this.props;
        switch(profile) {
            case 'analyst': return (
                <div>
                    <span style={{ 
                        marginLeft: '5px', 
                        fontStyle: 'italic', 
                        fontSize: '11px' 
                    }}>
                        {'Admin'}
                    </span>
                </div>
            );
        }
    }
}

class AccountButton extends Component {
    state = { bc: '#fff' }
    constructor(props) { super(props); }

    toggleBc = () => this.setState({...this.state, bc: this.state.bc === '#fff' ? 'rgb(179, 192, 199)' : '#fff' });

    render() {
        const
        { bc } = this.state,
        { type, clickEvent, trigger } = this.props;

        let icon, msg, borderRadius, marginRight;

        switch(type) {
            case 'logout':
                icon = 'logout';
                msg = 'Log Out';
                borderRadius = '4px 4px 0px 0px';
                marginRight = '20%';
                break;

            case 'account':
                icon = 'user';
                msg = 'Account';
                borderRadius = '0px 0px 4px 4px';
                marginRight = '20%';
                break;
        }

        return (
            <div
                className='ss-cmpts-acct-popo-btn-container'
                onClick={clickEvent}
                onMouseDown={() => this.toggleBc()}
                onMouseUp={() => this.toggleBc()}
            >
                <Card.Grid style={{
                    backgroundColor: bc,
                    padding: '5px 10px',
                    textAlign: 'left',
                    width: '100%',
                    borderRadius: borderRadius,
                    borderStyle: 'none',
                    borderWidth: '0px',
                    cursor: 'pointer'
                }}>
                    <div style={{ display: 'inline-block', marginRight: marginRight }}>
                        <Icon type={icon} />
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        {msg}
                    </div>
                </Card.Grid>
            </div>
        );
    }
}

export default class AccountPopover extends Component {
    constructor(props) { super(props); }
    render() {
        const
        { services, trigger } = this.props,
        { USER_DETAILS } = session.jwtSession;

        return (
            <div className='ss-cmpts-acct-popo-container'>
                <div>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '4px' }}>
                        <Col span={24}>
                            <Type {...this.props} />
                        </Col>
                    </Row>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col span={24}>
                            <div>
                                <span style={{ marginLeft: '5px', fontSize: '13px', fontWeight: 'bold', fontStyle: 'italic' }}>
                                    {`${USER_DETAILS.FIRST_NAME} ${USER_DETAILS.LAST_NAME}`}
                                </span>
                            </div>
                        </Col>
                    </Row>
                </div>
                <Divider type='horizontal' style={{ margin: '10px 0px' }}/>
                <Card
                    bodyStyle={{
                        borderColor: '#fff',
                        backgroundColor: '#fff',
                        padding: '4px'
                    }}
                    style={{
                        textAlign: 'center',
                        width: '100%',
                        background: '#fff',
                        borderRadius: '4px',
                        borderColor: 'white',
                        borderStyle: 'solid',
                        overflow: 'hidden',
                        margin: '-13px 0px'
                    }}
                >
                    <AccountButton type='logout' trigger={trigger} clickEvent={logout}/>
                    <AccountButton type='account' trigger={trigger} clickEvent={services.toggleAccountModal}/>
                </Card>
            </div>
        )
    }
}
